import equal from 'fast-deep-equal';
import {DependencyList, useEffect, useRef} from 'react';

export function useEffectAfterMount(effect: (() => void) | (() => () => void), deps: DependencyList) {
  const initialRun = useRef(false);
  const prevDeps = useRef<DependencyList>(deps);

  useEffect(() => {
    // First render - store the dependencies and mark as initialized
    if (!initialRun.current) {
      initialRun.current = true;
      prevDeps.current = deps;
      return;
    }

    // Check if dependencies actually changed using deep equality
    const depsChanged = !equal(prevDeps.current, deps);

    if (depsChanged) {
      // Store new dependencies
      prevDeps.current = deps;
      // Run the effect
      return effect();
    }
  }, [deps, effect]);
}
